import { gql, useMutation } from '@apollo/client';
import {
  Payments_RecordCheckPaymentMutation,
  Payments_RecordCheckPaymentMutationVariables,
} from '@/types';

const RECORD_CHECK_PAYMENT_RESPONSE_FRAGMENT = gql`
  fragment RecordCheckPaymentResponseFields on RecordCheckPaymentResponse {
    alert_level
    alert_message
    payment_batch_id
  }
`;

export const RECORD_CHECK_PAYMENT_MUTATION = gql`
  mutation Payments_RecordCheckPayment(
    $checkNumber: String!
    $creditMemos: [PartialPaymentCreditMemoInput!]
    $creditRequestBatchLineItems: [CreditRequestBatchLineItemInput!]
    $invoices: [PartialPaymentInvoiceInput!]!
    $memo: String
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    recordCheckPayment(
      check_number: $checkNumber
      credit_memos: $creditMemos
      credit_request_batch_line_items: $creditRequestBatchLineItems
      invoices: $invoices
      memo: $memo
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      ...RecordCheckPaymentResponseFields
    }
  }
  ${RECORD_CHECK_PAYMENT_RESPONSE_FRAGMENT}
`;

export const useRecordCheckPayment = () => {
  return useMutation<
    Payments_RecordCheckPaymentMutation,
    Payments_RecordCheckPaymentMutationVariables
  >(RECORD_CHECK_PAYMENT_MUTATION);
};
